import { ContextReducerInterface } from "../duck/types";
import Store from "../store";

export const getContext = (): ContextReducerInterface => {
    return Store.getState().context;
};
